(function () {
    'use strict';

    var subPriceText = '';
    var oncePriceText = '';
    var subPriceEl, savingEl, summary, oncePriceEl, freqSelect, widget, joyWidget;
    var currentVariantId = null;

    var enToFr = {
      'Every month': 'Tous les mois',
      'Every 2 months': 'Tous les 2 mois',
      'Every 3 months': 'Tous les 3 mois',
      'Every 4 months': 'Tous les 4 mois',
      'Every 5 months': 'Tous les 5 mois',
      'Every 6 months': 'Tous les 6 mois',
      'Every 7 months': 'Tous les 7 mois',
      'Every 8 months': 'Tous les 8 mois',
      'Every 9 months': 'Tous les 9 mois',
      'Every 10 months': 'Tous les 10 mois',
      'Every 11 months': 'Tous les 11 mois',
      'Every 12 months': 'Tous les 12 mois'
    };

    function formatPrice(cents) {
      return (cents / 100).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + '\u00a0€';
    }
  
    function parsePriceText(text) {
      if (!text) return NaN;
      return parseFloat(text.replace(/[^0-9,]/g, '').replace(',', '.'));
    }

    function i18n(key, fallback) {
      return (window.persI18n && window.persI18n[key]) ? window.persI18n[key] : fallback;
    }
  
    function getPriceFromAvada(variantId, planId) {
      var avada = window.AVADA_SUBSCRIPTION;
      if (!avada || !avada.product || !avada.product.variants) return null;
      var variant = null;
      avada.product.variants.forEach(function (v) {
        if (String(v.id) === String(variantId)) variant = v;
      });
      if (!variant || !variant.selling_plan_allocations) return null;
      var allocation = null;
      variant.selling_plan_allocations.forEach(function (a) {
        if (String(a.selling_plan_id) === String(planId)) allocation = a;
      });
      if (!allocation) return null;
      return { price: allocation.price, compareAt: allocation.compare_at_price };
    }

    function getVariantBasePrice(variantId) {
      var avada = window.AVADA_SUBSCRIPTION;
      if (!avada || !avada.product || !avada.product.variants) return null;
      var found = null;
      avada.product.variants.forEach(function (v) {
        if (String(v.id) === String(variantId)) found = v;
      });
      return found ? found.price : null;
    }

    function updatePricesForVariantAndPlan(variantId, planId) {
      var prices = getPriceFromAvada(variantId, planId);
      if (prices) {
        subPriceText = formatPrice(prices.price);
        var savedCents = prices.compareAt - prices.price;
        if (subPriceEl) subPriceEl.textContent = subPriceText;
        if (savingEl) savingEl.textContent = i18n('youSave', 'Vous économisez ') + formatPrice(savedCents);
      } else {
        var basePrice = parsePriceText(oncePriceText);
        if (!isNaN(basePrice) && window.persSPG) {
          window.persSPG.forEach(function (group) {
            group.selling_plans.forEach(function (plan) {
              if (String(plan.id) === String(planId)) {
                var adj = plan.price_adjustments && plan.price_adjustments[0];
                if (adj && adj.value_type === 'percentage') {
                  var discounted = basePrice * (1 - adj.value / 100);
                  var savedAmt = basePrice - discounted;
                  subPriceText = formatPrice(discounted * 100);
                  if (subPriceEl) subPriceEl.textContent = subPriceText;
                  if (savingEl) savingEl.textContent = i18n('youSave', 'Vous économisez ') + formatPrice(savedAmt * 100);
                }
              }
            });
          });
        }
      }
    }

    function updateSummary(type) {
      if (!summary) return;
      if (type === 'subscription' && freqSelect && freqSelect.options.length > 0) {
        var planName = freqSelect.options[freqSelect.selectedIndex].text.toLowerCase();
        summary.innerHTML = i18n('totalPriceSub', 'Prix total\u00a0: ') + '<strong>' + subPriceText + '</strong> \u2014 ' + i18n('subscription', 'abonnement ') + planName;
      } else {
        summary.innerHTML = i18n('totalPriceOnce', 'Prix total\u00a0: ') + '<strong>' + oncePriceText + '</strong> \u2014 ' + i18n('oneTimePurchase', 'achat unique');
      }
    }

    function updateStickyATC(type) {
      // Synchroniser le selling_plan dans le formulaire sticky
      var stickyInput = document.querySelector('#addtocart-sticky input[name="selling_plan"]');
      if (stickyInput) {
        if (type === 'subscription' && freqSelect && freqSelect.value) {
          stickyInput.value = freqSelect.value;
        } else {
          stickyInput.value = '';
        }
      }

      // Mettre à jour le prix affiché dans la modale sticky
      var stickyPrice = document.querySelector('#addtocart-sticky p strong');
      if (stickyPrice) {
        stickyPrice.textContent = (type === 'subscription') ? subPriceText : oncePriceText;
      }
    }

    function syncToJoy(planId) {
      if (joyWidget) {
        var joyHidden = joyWidget.querySelector('input[type="hidden"]');
        if (joyHidden) joyHidden.value = planId;
      }
      document.querySelectorAll('input[name="selling_plan"]').forEach(function (i) {
        i.value = planId;
      });
    }
  
    function getCurrentType() {
      if (!widget) return 'one_time';
      var selected = widget.querySelector('.pers-option.selected');
      return selected ? selected.dataset.type : 'one_time';
    }

    function getUrlVariantId() {
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : null;
    }

    // Masque la carte abonnement pour les variantes sans plan (selling_plan_allocations === 0)
    function applySubAvailability(variantId) {
      if (!widget) return;
      if (variantId === null || variantId === undefined) return; // variante inconnue → on ne masque rien
      var subOption = widget.querySelector('.pers-option--sub');
      if (!subOption) return;

      var map = window.persVariantSub || {};
      var hasSub = Number(map[String(variantId)]) > 0;
  
      if (hasSub) {
        subOption.style.display = '';
        return;
      }

      // Abonnement indisponible pour cette variante → masquer tout l'abonnement
      subOption.style.display = 'none';
      var freqBlock = document.getElementById('pers-frequency');
      var modalTrigger = document.getElementById('pers-modal-trigger');
      if (freqBlock) freqBlock.classList.remove('visible');
      if (modalTrigger) modalTrigger.classList.remove('visible');

      // Si l'abonnement était sélectionné, forcer l'achat unique
      if (getCurrentType() === 'subscription') {
        var options = widget.querySelectorAll('.pers-option');
        var onceOption = widget.querySelector('.pers-option--once');
        options.forEach(function (o) { o.classList.remove('selected'); });
        if (onceOption) onceOption.classList.add('selected');
        document.querySelectorAll('input[name="selling_plan"]').forEach(function (i) { i.value = ''; });
        if (joyWidget) {
          var joyOnceOpt = joyWidget.querySelector('[avada-data-value="one-time-purchase"]');
          if (joyOnceOpt) joyOnceOpt.click();
        }
        updateSummary('one_time');
        updateStickyATC('one_time');
      }
    }

    function buildFrequencySelect() {
      if (!window.persSPG || !freqSelect) return;
      var avada = window.AVADA_SUBSCRIPTION;
      var avadaPlans = {};
      if (avada && avada.subscriptionProduct && avada.subscriptionProduct.plans) {
        avada.subscriptionProduct.plans.forEach(function (p) {
          avadaPlans[String(p.sellingPlanId)] = p;
        });
      }
      var lang = (document.documentElement.lang || 'fr').split('-')[0];
      var allPlans = [];
      window.persSPG.forEach(function (group) {
        group.selling_plans.forEach(function (plan) {
          var planName = plan.name;
          var joyPlan = avadaPlans[String(plan.id)];
          if (joyPlan && joyPlan.translations && joyPlan.translations[lang] && joyPlan.translations[lang].title) {
            planName = joyPlan.translations[lang].title;
          } else if (lang === 'fr' && enToFr[plan.name]) {
            planName = enToFr[plan.name];
          }
          var months = 999;
          var match = plan.name.match(/(\d+)/);
          if (match) months = parseInt(match[1]);
          allPlans.push({ id: plan.id, name: planName, months: months });
        });
      });
      allPlans.sort(function (a, b) { return a.months - b.months; });
      freqSelect.innerHTML = '';
      allPlans.forEach(function (plan) {
        var opt = document.createElement('option');
        opt.value = plan.id;
        opt.textContent = plan.name;
        freqSelect.appendChild(opt);
      });
    }

    function initModal() {
      var trigger = document.getElementById('pers-modal-trigger');
      var overlay = document.getElementById('pers-modal-overlay');
      var closeBtn = document.getElementById('pers-modal-close');
      if (!trigger || !overlay) return;
      trigger.addEventListener('click', function () {
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
      function closeModal() {
        overlay.classList.remove('open');
        document.body.style.overflow = '';
      }
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    }

    function hidejoyBadge() {
      var badge = document.querySelector('[data-save-price].Avada-Subscription-Price__Badge');
      if (badge) badge.style.setProperty('display', 'none', 'important');
    }

    function watchJoyBadge() {
      hidejoyBadge();
      var observer = new MutationObserver(function () {
        var badge = document.querySelector('[data-save-price].Avada-Subscription-Price__Badge');
        if (badge && badge.style.display !== 'none') {
          badge.style.setProperty('display', 'none', 'important');
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
    }

    function onVariantChanged(newVariantId) {
      if (String(newVariantId) === String(currentVariantId)) return;
      currentVariantId = newVariantId;
      var baseCents = getVariantBasePrice(newVariantId);
      if (baseCents !== null) {
        oncePriceText = formatPrice(baseCents);
        if (oncePriceEl) oncePriceEl.textContent = oncePriceText;
        var originalPriceEl = widget.querySelector('.pers-price--original');
        if (originalPriceEl) originalPriceEl.textContent = oncePriceText;
      }
      if (freqSelect && freqSelect.value) {
        updatePricesForVariantAndPlan(newVariantId, freqSelect.value);
      }
      var type = getCurrentType();
      updateSummary(type);
      updateStickyATC(type);
      applySubAvailability(newVariantId);
    }

    function watchVariantInputs() {
      var variantInputs = document.querySelectorAll('[data-variant-input]');
      variantInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          setTimeout(function () {
            var avada = window.AVADA_SUBSCRIPTION;
            if (!avada || !avada.product || !avada.product.variants) return;
            var selectedOptions = {};
            document.querySelectorAll('[data-variant-input]:checked').forEach(function (checked) {
              var idx = checked.getAttribute('data-index');
              selectedOptions[idx] = checked.value;
            });
            avada.product.variants.forEach(function (v) {
              var match = true;
              Object.keys(selectedOptions).forEach(function (idx) {
                var optNum = idx.replace('option', '');
                if (v['option' + optNum] !== selectedOptions[idx]) match = false;
              });
              if (match) onVariantChanged(v.id);
            });
          }, 50);
        });
      });
      document.addEventListener('variant:changed', function (e) {
        var variant = e.detail && e.detail.variant;
        if (variant) onVariantChanged(variant.id);
      });
    }

    function initWidget() {
      widget = document.querySelector('.pers-purchase-widget');
      if (!widget) return;

      joyWidget = document.querySelector('.Avada-Subscription__Block');
      freqSelect = document.getElementById('pers-freq-select');
      subPriceEl = document.getElementById('pers-sub-price');
      savingEl = document.getElementById('pers-saving');
      summary = document.getElementById('pers-price-summary');
      oncePriceEl = widget.querySelector('.pers-price--once');

      var avada = window.AVADA_SUBSCRIPTION;
      if (avada && avada.product) {
        currentVariantId = avada.product.selectedVariant;
      }

      if (oncePriceEl) {
        var baseCents = currentVariantId ? getVariantBasePrice(currentVariantId) : null;
        if (baseCents !== null) {
          oncePriceText = formatPrice(baseCents);
          oncePriceEl.textContent = oncePriceText;
        } else {
          var rawPrice = parsePriceText(oncePriceEl.textContent.trim());
          oncePriceText = !isNaN(rawPrice) ? rawPrice.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€' : oncePriceEl.textContent.trim();
          oncePriceEl.textContent = oncePriceText;
        }
      }

      var originalPriceElInit = widget.querySelector('.pers-price--original');
      if (originalPriceElInit) originalPriceElInit.textContent = oncePriceText;

      buildFrequencySelect();

      if (freqSelect && freqSelect.value && currentVariantId) {
        updatePricesForVariantAndPlan(currentVariantId, freqSelect.value);
      }

      // Clics sur les cartes
      var options = widget.querySelectorAll('.pers-option');
      options.forEach(function (option) {
        option.addEventListener('click', function () {
          var type = option.dataset.type;
          options.forEach(function (o) { o.classList.remove('selected'); });
          option.classList.add('selected');

          var freqBlock = document.getElementById('pers-frequency');
          var modalTrigger = document.getElementById('pers-modal-trigger');

          if (type === 'subscription') {
            if (freqBlock) freqBlock.classList.add('visible');
            if (modalTrigger) modalTrigger.classList.add('visible');
            if (freqSelect && freqSelect.value) {
              syncToJoy(freqSelect.value);
              if (currentVariantId) updatePricesForVariantAndPlan(currentVariantId, freqSelect.value);
            }
            if (joyWidget) {
              var joySubOpt = joyWidget.querySelector('[avada-data-value="subscribe-and-save"]');
              if (joySubOpt) joySubOpt.click();
            }
          } else {
            if (freqBlock) freqBlock.classList.remove('visible');
            if (modalTrigger) modalTrigger.classList.remove('visible');
            document.querySelectorAll('input[name="selling_plan"]').forEach(function (i) { i.value = ''; });
            if (joyWidget) {
              var joyOnceOpt = joyWidget.querySelector('[avada-data-value="one-time-purchase"]');
              if (joyOnceOpt) joyOnceOpt.click();
            }
          }
          updateSummary(type);
          updateStickyATC(type);
        });
      });

      // Changement de fréquence
      if (freqSelect) {
        freqSelect.addEventListener('change', function () {
          syncToJoy(freqSelect.value);
          if (currentVariantId) updatePricesForVariantAndPlan(currentVariantId, freqSelect.value);
          updateSummary('subscription');
          updateStickyATC('subscription');
        });
      }

      watchVariantInputs();
      initModal();
      watchJoyBadge();
  
      // Init — achat unique sélectionné par défaut
      var freqBlockInit = document.getElementById('pers-frequency');
      if (freqBlockInit) freqBlockInit.classList.remove('visible');
      var modalTriggerInit = document.getElementById('pers-modal-trigger');
      if (modalTriggerInit) modalTriggerInit.classList.remove('visible');
      document.querySelectorAll('input[name="selling_plan"]').forEach(function (i) { i.value = ''; });
      if (joyWidget) {
        var joyOnceInit = joyWidget.querySelector('[avada-data-value="one-time-purchase"]');
        if (joyOnceInit) joyOnceInit.click();
      }
      updateSummary('one_time');
      updateStickyATC('one_time');
      applySubAvailability(currentVariantId || getUrlVariantId());
    }

    function waitForJoy() {
      if (document.querySelector('.Avada-Subscription__Block')) {
        initWidget();
      } else {
        setTimeout(waitForJoy, 200);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForJoy);
    } else {
      waitForJoy();
    }
  
})();